export enum AcaoConferencia {
  ADICIONADO = "ADICIONADO",
  REMOVIDO = "REMOVIDO",
}

export enum AcaoConferenciaDescritivo {
  ADICIONADO = "ADICIONADO",
  REMOVIDO = "REMOVIDO",
}

export type ConferenciaVendaLogDTO = {
  usuario: string;
  acao: AcaoConferencia;
  dataHora: string;
  caixa: string;
  skuDescritivo: string;
  quantidade: number;
};
